import React from 'react';

/**
 * Shared empty list UI (inventory admin pages).
 * @param {React.ComponentType<{ size?: number; strokeWidth?: number }>} Icon - lucide-react icon
 */
export default function EmptyStateBlock({ Icon, title, description, compact = false, className = '' }) {
    const pad = compact ? 'py-8' : 'py-14';
    return (
        <div
            className={`flex flex-col items-center justify-center ${pad} px-6 mt-2 mx-auto max-w-lg rounded-2xl border border-dashed border-line bg-gradient-to-b from-surface-2/90 to-surface text-center ${className}`}
            role="status"
            aria-live="polite"
        >
            <div
                className="flex h-[4.5rem] w-[4.5rem] items-center justify-center rounded-2xl bg-primary-soft text-brand-cyan shadow-sm ring-1 ring-brand-indigo/30 mb-5"
                aria-hidden
            >
                <Icon size={40} strokeWidth={1.5} />
            </div>
            <h3 className="text-lg font-semibold text-ink tracking-tight">{title}</h3>
            <p className="mt-2 text-sm text-ink-muted max-w-md leading-relaxed">{description}</p>
        </div>
    );
}
